import React from 'react';
import cx from 'classnames';
import useStyles from 'isomorphic-style-loader-react18/useStyles';
import s from './NotificationBubble.less';

interface BubbleProps {
  count: number;
  topOffset?: string;
  rightOffset?: string;
  success?: boolean;
  info?: boolean;
  warning?: boolean;
  danger?: boolean;
}

const NotificationBubble = ({
  count,
  topOffset = '-4px',
  rightOffset = '-4px',
  success,
  info,
  warning,
  danger,
}: BubbleProps) => {
  useStyles(s);

  const style = {
    top: topOffset,
    right: rightOffset,
  };

  const classNames = cx(s.bubble, {
    [s.success]: !!success,
    [s.info]: !!info,
    [s.warning]: !!warning,
    [s.danger]: !!danger,
  });
  return (
    <div className={classNames} style={style}>
      {count}
    </div>
  );
};

export default NotificationBubble;
